import { Logger } from './logger';

class TouchDetect {
  constructor() {
    this.started = false;
    this.log = new Logger('ah_touchdetect');
  }

  start(elem) {
    if (!this.started) {
      this.log.debug('starting touch detection');

      this.touch = false;
      this.elem = elem;
      this.elem.classList.add('ah-no-touch');

      const check = () => {
        this.touch = true;
        this.elem.classList.remove('ah-no-touch');
        this.elem.classList.add('ah-touch');
        this.elem.removeEventListener('touchstart', check);
        this.log.debug('touch detected');
      };

      this.elem.addEventListener('touchstart', check);
      this.started = true;
    }
  }
}

export default new TouchDetect();
